const minutesInHour = 60;

export const convertToMinutes = (time) => {
  const digits = time.split(':').map((digitGroup) => +digitGroup);

  return digits[0] * minutesInHour + digits[1];
};

export const createTimeBlocksFromExistingArray = (
  times,
  startTime,
  endTime,
) => {
  const timeBlocks = times.map((time) => ({
    time,
    duration: 1,
    error: false,
  }));

  const updatedTimeBlocks = recalculateDurations(
    timeBlocks,
    startTime,
    endTime,
  );

  return updatedTimeBlocks;
};

export const generateTimes = (startTime, endTime, duration) => {
  let startTimeInt = convertToMinutes(startTime);
  const endTimeInt = convertToMinutes(endTime);
  const times = [];
  const minutesIncrement = duration * minutesInHour;

  for (let i = 0; startTimeInt < endTimeInt; i++) {
    const hour = Math.floor(startTimeInt / minutesInHour);
    const minutes = startTimeInt % minutesInHour;

    times[i] = {
      time: `${hour}:${`${minutes}`.padEnd(2, '0')}:00`,
      duration: minutesIncrement / minutesInHour,
      error: false,
    };

    startTimeInt += minutesIncrement;
  }

  // Update duration calculation for last entry
  const lastTime = times[times.length - 1];
  if (lastTime) {
    const lastTimeInt = convertToMinutes(lastTime.time);
    lastTime.duration =
      Math.round(((endTimeInt - lastTimeInt) / minutesInHour) * 100) / 100;
  }

  return times;
};

export const getNewDuration = (currentTime, nextTime) => {
  const currentTimeInt = convertToMinutes(currentTime);
  const nextTimeInt = convertToMinutes(nextTime);

  const minutes = nextTimeInt - currentTimeInt;
  const duration = minutes / minutesInHour;

  return Math.round(duration * 100) / 100;
};

export const recalculateDurations = (times, startTime, endTime) => {
  const newTimes = [...times];
  newTimes.map((entry, idx) => {
    if (idx !== newTimes.length - 1) {
      const currentTime = entry.time;
      const nextTime = times[idx + 1].time;
      const newDuration = getNewDuration(currentTime, nextTime);

      entry.duration = newDuration;
      entry.error =
        convertToMinutes(entry.time) < convertToMinutes(startTime) ||
        convertToMinutes(entry.time) >= convertToMinutes(endTime);
    }
    return entry;
  });

  const lastEntry = newTimes[newTimes.length - 1];
  lastEntry.duration = getNewDuration(lastEntry.time, endTime);
  if (lastEntry.duration <= 0) lastEntry.error = true;

  return newTimes;
};
